import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility to merge tailwind classes safely
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Format price to currency
 */
export const formatPrice = (price: number | string, locale: string = 'ar-SA') => {
    const num = typeof price === 'string' ? parseFloat(price) : price;
    if (isNaN(num)) return '0.00 ر.س';

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'SAR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        useGrouping: true,
    }).format(num);
};

/**
 * Wait for a certain amount of time
 */
export const wait = (ms: number) => new Promise((res) => setTimeout(res, ms));
